import './scss/loading-splash-page.scss';
import { Themes } from './types';

export const ChooseTheme = ({ onThemeChange }: { onThemeChange: (theme: Themes) => void }) => {

    return (
        <div className='lex-loading-splash-page'>
            <h1>Welcome to LEX - Program legislatie</h1>
            <h2>Please choose a theme</h2>
            <button onClick={() => onThemeChange(Themes.VINTAGE)}>Vintage</button>
            <button onClick={() => onThemeChange(Themes.MODERN)}>Modern</button>
        </div>
    )
}